// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-66f5923f]{width:100%;height:58px;border-radius:3px;display:flex;flex-direction:row;align-items:center;justify-content:space-between;background-color:#fff;padding:0 20px;box-sizing:border-box;margin-bottom:20px;position:relative}.title[data-v-66f5923f]{font-size:1.42857rem;line-height:1.28571rem;font-weight:700;color:#0f2345}.buttons[data-v-66f5923f]{display:flex}.btn[data-v-66f5923f]{margin-left:15px}", ""]);
// Exports
module.exports = exports;
